import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', to: '/' },
  { label: '成功故事', to: '/stories' },
  { label: '本地仓储', to: '/warehouse' },
  { label: '情感课程', to: '/education' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md border-b border-gray-100' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-14 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg"
              alt="富缘佳旺 FortuneMatch Logo"
              className="w-9 h-9 md:w-10 md:h-10 rounded-full object-cover"
            />
            <div className="flex flex-col leading-tight">
              <span className={`text-base md:text-lg font-bold tracking-wide ${scrolled ? 'text-red-700' : 'text-white'}`} style={{ fontFamily: "'Noto Serif SC', serif" }}>富缘佳旺</span>
              <span className={`text-[10px] font-medium tracking-widest hidden sm:block ${scrolled ? 'text-red-400' : 'text-red-200'}`}>FortuneMatch</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((item, i) => (
              <Link
                key={i}
                to={item.to}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-red-600' : 'text-white/90 hover:text-white'}`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/membership"
              className={`flex items-center gap-1.5 text-sm font-semibold transition-all cursor-pointer whitespace-nowrap px-4 py-1.5 rounded-full border ${scrolled ? 'border-amber-400 text-amber-600 hover:bg-amber-50' : 'border-yellow-400/60 text-yellow-300 hover:bg-yellow-400/10'}`}
            >
              <i className="ri-vip-crown-line"></i> 会员中心
            </Link>
          </div>

          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/auth"
              className={`px-5 py-2 rounded-full text-sm font-medium border transition-all cursor-pointer whitespace-nowrap ${scrolled ? 'border-red-600 text-red-600 hover:bg-red-50' : 'border-white text-white hover:bg-white/10'}`}
            >
              <i className="ri-user-line mr-1"></i> 登录
            </Link>
            <Link
              to="/auth"
              className="px-5 py-2 rounded-full text-sm font-medium bg-red-600 text-white hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
            >
              免费注册
            </Link>
          </div>

          {/* Mobile Right: Login + Hamburger */}
          <div className="flex md:hidden items-center gap-2">
            <Link
              to="/auth"
              className={`text-xs font-medium px-3 py-1.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${scrolled ? 'border-red-600 text-red-600' : 'border-white/70 text-white'}`}
            >
              登录
            </Link>
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-all ${scrolled ? 'text-gray-700 bg-gray-100' : 'text-white bg-white/15'}`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Slide-down Menu */}
      <div
        className={`md:hidden fixed top-14 left-0 right-0 z-40 bg-white/97 backdrop-blur-xl border-b border-gray-100 transition-all duration-300 overflow-hidden ${mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="px-4 py-4 flex flex-col gap-1">
          {navLinks.map((item, i) => (
            <Link
              key={i}
              to={item.to}
              className="flex items-center gap-3 px-3 py-3 rounded-xl text-gray-700 text-sm font-medium hover:bg-red-50 hover:text-red-600 transition-all cursor-pointer"
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/membership"
            className="flex items-center gap-3 px-3 py-3 rounded-xl text-amber-600 text-sm font-semibold hover:bg-amber-50 transition-all cursor-pointer"
          >
            <i className="ri-vip-crown-line"></i> 会员中心
          </Link>
          <div className="pt-2 pb-1">
            <Link
              to="/auth"
              className="block w-full text-center py-3 rounded-xl bg-red-600 text-white text-sm font-semibold cursor-pointer whitespace-nowrap hover:bg-red-700 transition-all"
            >
              免费注册 · 开始缘分之旅
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu Backdrop */}
      {mobileOpen && (
        <div
          className="md:hidden fixed inset-0 z-30 bg-black/20 backdrop-blur-sm"
          onClick={() => setMobileOpen(false)}
        />
      )}
    </>
  );
}
